import styled from '@emotion/styled';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down.svg';
import { TextStyle } from 'styles/variables/mixins';
import { Colors } from 'styles/variables/colors';
import { NavLink as NavLinkComponent } from 'react-router-dom';

export const DropdownIcon = styled(ArrowDownIcon)`
    fill: inherit;
    width: 10px;
    margin-left: 4px;
    margin-right: 4px;
`;

export const DropDownMenu = styled.ul`
    max-width: 289px;
    border: 2px solid ${Colors.inputBorder};
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    max-height: 30rem;
    overflow: hidden;
    overflow-y: auto;
`;

export const HeaderMainSection = styled.div`
    ${TextStyle({ fontSize: '15px', fontWeight: '400' })}
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 70%;
`;

export const Img = styled.img`
    margin-right: 5px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: inline-block;
    object-fit: cover;
`;

export const Label = styled.div`
    ${TextStyle({ fontSize: '16px', fontWeight: '700', color: Colors.gray })};
    background-color: #f8f8f8;
    border-radius: 3px;
    height: 36px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    line-height: 1;
    white-space: nowrap;
    letter-spacing: -0.5px;
    width: fit-content;
`;

export const MenuItem = styled.div`
    padding: 0.5rem 1rem 0.5rem 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    :hover {
        background-color: #f8f8f8;
    }
`;

export const MenuItemText = styled.p`
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: ${Colors.blue};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: 13rem;
`;

export const NavLink = styled(NavLinkComponent)`
    padding: 0.5rem 1rem 0.5rem 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    :hover {
        background-color: #f8f8f8;
    }
`;

type DropdownProps = {
    isActive?: boolean;
};

export const PlaceholderImg = styled.span`
    margin-right: 5px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: inline-block;
    object-fit: cover;
`;

export const SelectClientDropdown = styled.div<DropdownProps>`
    display: flex;
    align-items: center;
    border: none;
    cursor: pointer;
`;

export const DropdownText = styled.p`
    color: ${Colors.blue};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 13rem;
    display: inline-block;
    font-size: 25px;
`;

export const DropdownPrompts = styled.p`
    ${TextStyle({ fontSize: '15px', fontWeight: '500', color: Colors.gray })}
    text-align: center;
`;

export const ToggleWrapper = styled.div`
    display: flex;
    gap: 30px;
    margin-left: auto;
`;

export const DocumentHeaderActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    flex-shrink: 0;
    flex-wrap: nowrap;
    margin-left: auto;
`;

export const DocumentActionButton = styled.button`
    height: 44px;
    padding: 0 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: none;
    border-radius: 14px;
    background: linear-gradient(135deg, #8353e2 0%, #6d41d8 100%);
    box-shadow: 0 12px 24px rgba(131, 83, 226, 0.22);
    color: #ffffff;
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease,
        background 0.2s ease;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 14px 28px rgba(131, 83, 226, 0.28);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.65;
    }

    svg,
    path {
        fill: currentColor;
    }
`;

export const ClientViewShell = styled.div<{ $fillProfile?: boolean }>`
    display: flex;
    flex-direction: column;
    min-width: 0;
    gap: 0.5rem;

    ${({ $fillProfile }) =>
        $fillProfile
            ? `
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden;

        > *:first-of-type {
            flex-shrink: 0;
        }
    `
            : ''}
`;
